'use strict';

var labelEnd = require('./label-end.js');

var labelStartLink = {
  name: 'labelStartLink',
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
};

function tokenizeLabelStartLink(effects, ok, nok) {
  var self = this;
  return start;

  function start(code) {
    effects.enter('labelLink');
    effects.enter('labelMarker');
    effects.consume(code);
    effects.exit('labelMarker');
    effects.exit('labelLink');
    return after;
  }

  function after(code) {
    /* c8 ignore next */
    return code === 94 &&
    /* c8 ignore next */
    '_hiddenFootnoteSupport' in self.parser.constructs ?
    /* c8 ignore next */
    nok(code) : ok(code);
  }
}

module.exports = labelStartLink;